import navigationData from '../data/navigation/navigation.json';

export interface AemContentFragment {
  navigationTitle: string | null;
  _path: string;
}

export interface NavigationItem {
  name: string;
  fragmentId: string;
  path: string;
  navigable: boolean;
  children: NavigationItem[];
}

export type NavigationData = {
  navigation: NavigationItem[];
}

// Alias for readability if needed
export type ResolvedNavigationItem = NavigationItem;

export const navigationConfig: NavigationItem[] = navigationData.navigation || [];

export const resolveNavigation = (
  config: NavigationItem[],
  fragments: AemContentFragment[]
): ResolvedNavigationItem[] => {
  const fragmentMap = new Map<string, AemContentFragment>();
  fragments.forEach(fragment => {
    fragmentMap.set(fragment._path, fragment);
  });

  const resolveItem = (item: NavigationItem): ResolvedNavigationItem => {
    const fragment = fragmentMap.get(item.fragmentId);
    const name = fragment?.navigationTitle || item.name;

    return {
      ...item,
      name,
      path: item.path,
      children: item.children ? item.children.map(resolveItem) : [],
    };
  };

  return config.map(resolveItem);
};
